// Importing Project component.
import { ProjectThumbnail as Project } from "./Project";

/**
 * Projects component.
 */
export default function Projects() {
  return (
    <div className="container2" id="projects">
      {/* Title */}
      <h2 className="title">Projects</h2>

      {/* Projects list */}
      <div className="projects">
        <Project
          img={require("../images/kobem/thumbnail.webp")}
          title="Kobe.M / Client Portfolio"
          field="UI/UX Designer & Front-End Developer"
          desc={
            "Neo-brutalist client portfolio where the scroll is the interface: a hero image that flies into the next section, a horizontally-scrolling photo gallery, and a projects section that stands still while its content changes."
          }
          skills={[
            "Next.js",
            "React",
            "TypeScript",
            "Tailwind CSS",
            "Framer Motion",
            "Lenis",
            "Figma",
          ]}
          path="/portfolio/kobem"
        />
        <Project
          img={require("../images/ludi/thumbnail.webp")}
          title="Ludi"
          field="Full-Stack Web development"
          desc={
            "A personal game library and discovery app that pulls live metadata and pricing into one place — search, track, and rank the games you own or want."
          }
          skills={["Next.js", "React", "TypeScript", "Tailwind CSS", "Supabase", "Figma"]}
          path="/portfolio/ludi"
        />
      </div>
    </div>
  );
}
